<template>
    <report id="epsi-combined" :key="key">
        <template v-if="loading">
            <survey-loader cover spinner-size="lg" />
        </template>
        <template v-else>
            <cover-page :name="context" :date="$filters.date(report.dateReport.date)" :participantsCompleted="participantsCompletedInvited" />
            <page>
                <content-wrapper>
                    <survey-translate :base="type" name="INTRO_START_TEAM" :args="{ context }" raw />
                    <survey-title>{{ $t(`${type}.INTRO_TITLE`) }}</survey-title>
                    <survey-translate tag="p" :base="type" name="INTRO_TEASER" raw />
                </content-wrapper>
                <team-compare-question
                    :categoryKey="CategoryType.General"
                    :context="context"
                    :scores="epsiCSelected ? scores(epsiCReportData, CategoryType.General) : []"
                    :secondary-scores="epsiASelected ? scores(epsiAReportData, CategoryType.General) : []"
                    :type="'reportsWeb'"
                    :options="[]"
                    :loading="comparing"
                    :quarters="['Minimum', 'Maximum']"
                    :thresholdPrefix="thresholdPrefix"
                    show-deviation
                />
                <div class="toggle-buttons">
                    <survey-checkbox @click="epsiCSelected = !epsiCSelected" v-model="epsiCSelected" :class="{ epsiC: epsiCSelected }">
                        <span>{{ $t(`${type}.EPSI_C_LABEL`) }}</span>
                    </survey-checkbox>
                    <survey-checkbox @click="epsiASelected = !epsiASelected" v-model="epsiASelected" :class="{ epsiA: epsiASelected }">
                        <span>{{ $t(`${type}.EPSI_A_LABEL`) }}</span>
                    </survey-checkbox>
                </div>
            </page>

            <page>
                <template v-for="key in categoryKeys" :key="`question_${key}`">
                    <team-compare-question
                        :categoryKey="CategoryType[key]"
                        :context="context"
                        :scores="epsiCSelected ? scores(epsiCReportData, CategoryType[key]) : []"
                        :secondary-scores="epsiASelected ? scores(epsiAReportData, CategoryType[key]) : []"
                        :type="'reportsWeb'"
                        :options="[]"
                        :quarters="['Minimum', 'Maximum']"
                        :loading="comparing"
                        :thresholdPrefix="thresholdPrefix"
                        show-deviation
                    />

                    <div class="toggle-buttons">
                        <survey-checkbox @click="epsiCSelected = !epsiCSelected" v-model="epsiCSelected" :class="{ epsiC: epsiCSelected }">
                            <span>{{ $t(`${type}.EPSI_C_LABEL`) }}</span>
                        </survey-checkbox>
                        <survey-checkbox @click="epsiASelected = !epsiASelected" v-model="epsiASelected" :class="{ epsiA: epsiASelected }">
                            <span>{{ $t(`${type}.EPSI_A_LABEL`) }}</span>
                        </survey-checkbox>
                    </div>
                </template>
            </page>
        </template>
    </report>
</template>
<script src="./EpsiCombined.ts"></script>
<style lang="scss">
.toggle-buttons {
    display: flex;
    flex-direction: column;
    margin: 1rem 0;

    .survey-checkbox {
        margin-bottom: 0;
        &.epsiC {
            .survey-checkbox-label {
                .survey-checkbox-control.checked::before {
                    background: rgba(236, 103, 26, 0.75) !important;
                }
            }
        }

        &.epsiA {
            .survey-checkbox-control.checked:before {
                background: rgba(184, 184, 184, 0.75) !important;
            }
        }
    }
}
</style>
